export type ButtonVariant =
  | 'blue'
  | 'blueGray'
  | 'blueGrayInverted'
  | 'black'
  | 'bright'
  | 'cancel'
  | 'dark'
  | 'ghost'
  | 'inactive'
  | 'inactiveGray'
  | 'light'
  | 'lightRounded'
  | 'mediumGray'
  | 'transparent'
  | 'navy'
  | 'navyAccent'
  | 'secondary'
  | 'settings'
  | 'tertiary'
  | 'outlined'
  | 'outlinedSlim'
  | 'outlinedSecondary'
  | 'roundWhite'
  | 'roundRed'
  | 'round'
  | 'charcoalBlue'
  | 'white';

export const VARIANT: Record<ButtonVariant, string> = {
  black: 'bg-base-black text-white',
  blue: 'bg-[#0a5dd1] text-white',
  bright: 'bg-primary text-darkNavy', // TODO: Update primary color in theme or remove bright all together
  cancel: 'bg-red text-white hover:brightness-[0.9]',
  dark: 'bg-secondary text-white hover:brightness-[0.9]',
  ghost: 'border border-white/40 text-white/40',
  inactive: 'cursor-default border-2 border-whiteGray bg-transparent text-whiteGray',
  inactiveGray: 'bg-base-white opacity-50 text-base-primary',
  light: 'bg-white text-darkNavy',
  lightRounded: 'bg-white text-base-black rounded-[100px] font-FoxOneAero',
  mediumGray: 'bg-mediumGray text-white',
  navy: 'bg-veryLightGray hover:!bg-navyAccent hover:text-white/100',
  navyAccent: 'bg-navyAccent text-white',
  secondary: 'border-2 border-secondary bg-white text-secondary',
  settings:
    'justify-normal 2xsm:justify-center h-[56px] w-full max-w-[300px] rounded-[8px] px-[16px] text-left font-FoxOneAero text-[17px] font-medium leading-[22px] text-base-white',
  charcoalBlue: 'bg-charcoalBlue text-white hover:bg-ebonyClay',
  blueGray: 'bg-blueGray text-gray hover:!bg-gray hover:!text-white',
  blueGrayInverted: 'bg-white text-black hover:!bg-gray hover:!text-white',
  transparent: 'bg-transparent',
  outlined:
    'rounded-[8rem] border-2 border-gray px-8 font-FoxOneAeroBold !uppercase hover:border-white hover:bg-white hover:text-black',
  outlinedSlim: 'border border-base-white px-8 rounded-[100px] font-FoxOneAero',
  outlinedSecondary:
    'rounded-lg border border-gray py-1 px-4 !leading-2 !w-auto !font-FoxOneAero !text-[17px] font-light hover:border-white hover:bg-white hover:text-black',
  roundWhite: 'rounded-full',
  roundRed: 'rounded-full bg-red',
  round: 'rounded-full',
  white: 'rounded-[12px] bg-white text-charcoalBlue',
  tertiary: 'bg-white/10 text-white',
};

// TODO tailwindcss variant classes are not being linted (ESLint does not lint them), figure out a way to lint them, or use cn(), with cn() it works
